import Home from "@/scenes/Home";

export const routers: any = [
  {
    path: '/Home',
    name: '首页',
    title: '首页',
    component: Home,
  }
]
